import React from 'react';
import { BrandIcon } from '../branding/BrandAsset';
import './BrandLoader.css';

/** An icon-only loader shared by the main app and dashboard. */
const BrandLoader = () => (
  <div className="protrades-loader" role="status" aria-label="Loading ProTradesInsight">
    <BrandIcon
      surface="light"
      className="protrades-loader__icon"
      alt=""
      aria-hidden="true"
    />
  </div>
);

export default BrandLoader;
